import { Partner } from '../../models/partners.interfaces';

export const Partners5ItemsMocks: Partner[] = [
  {
    id: 'earnMilesWithEveryLyft',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/lyft-logo.svg',
      alt: 'Lyft Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com/'
    },
    title: 'Earn Miles With Every Lyft'
  },
  {
    id: 'earnMilesWithStarbucks',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/starbucks-logo.svg',
      alt: 'Starbucks Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.deltalyft.com/'
    },
    title: 'Earn Miles With Starbucks'
  },
  {
    id: 'earnMilesWithEveryOrder',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/instacart-logo.svg',
      alt: 'Instacart Logo'
    },
    action: {
      label: 'Link Account',
      url: 'https://www.delta.com/instacart'
    },
    title: 'Earn Miles With Every Order'
  },
  {
    id: 'earnMileWithAirbnb',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/airbnb-logo.svg',
      alt: 'Airbnb Logo'
    },
    action: {
      label: 'Book Now',
      url: 'https://www.deltaairbnb.com'
    },
    title: 'Earn 1 Mile per $1 spent with Airbnb'
  },
  {
    id: 'earnMilesBookingWithTicketmaster',
    logo: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/ticket-master-logo.svg',
      alt: 'Ticketmaster Logo'
    },
    action: {
      label: 'Buy Now',
      url: 'https://www.deltaticketmaster.com/'
    },
    title: 'Earn Miles Booking With Ticketmaster'
  }
];
